/*
 * base-upload
 * author zhousheng
 */
import Upload from './Upload';
import { UploadProps } from './interface';
export { UploadProps };
export default Upload;
